<template>
  <div class="container" :class="isReady ? 'page-show' : 'page-hide'">
    <div class="detail-header">
      <h3 class="title">{{ baseInfo.gonggaoTitle }}</h3>
      <div class="detail-info flex">
        <div class="detail-info-item">
          <span>报名截止</span>
          <span class="mt-20">{{ baseInfo.endTime | formatterDateTime }}</span>
        </div>
        <div class="detail-info-item">
          <span>预算金额</span>
          <span class="mt-20 color-theme-red">{{
            baseInfo.budgetMoneyFormat
          }}</span>
        </div>
        <div class="detail-info-item">
          <span>项目状态</span>
          <span
            class="mt-20"
            :class="
              baseInfo.status === '11' || baseInfo.status === '12'
                ? 'color-999'
                : baseInfo.signUpUrl
                ? 'color-theme-red'
                : 'color-999'
            "
            >{{ baseInfo.statusName }}</span
          >
        </div>
        <div class="detail-info-item">
          <span>操作</span>
          <el-button
            v-if="baseInfo.status === '11' || baseInfo.status === '12'"
            type="primary"
            class="application-btn disabled"
            @click="openLogin"
            >{{ baseInfo.btnName }}</el-button
          >
          <el-button
            v-else
            type="primary"
            :disabled="!baseInfo.signUpUrl"
            class="application-btn"
            @click="openLogin"
            >{{ baseInfo.btnName }}</el-button
          >
        </div>
      </div>
    </div>
    <!-- 多标段列表 -->
    <detail-list
      v-if="sectionList.length > 1 && !sectionId"
      :list="sectionList"
    />
    <!-- 详情 -->
    <detail-info
      v-else-if="baseInfo.infoid"
      :base-info="baseInfo"
      :section-id="sectionId"
      @setTitle="setTitle"
    />
  </div>
</template>

<script>
import purchaseApi from "@/api/purchase";
import { formatterDateTime } from "@/filters";
import { PROJECT_STATUS_BUTTON_TEXT } from "@/utils/constant";
import { getSEOConfig, setPageSEO } from "@/utils/seoConfig";

export default {
  name: "ProjectInfo",
  components: {
    DetailList: () => import("./components/detailList.vue"),
    DetailInfo: () => import("./components/detailInfo.vue"),
  },
  props: {},
  data() {
    return {
      isReady: false,
      id: "",
      infoid: "",
      sectionId: "",
      baseInfo: {},
      sectionList: [],
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const params = this.$route.query;
    this.id = params.id;
    this.infoid = params.infoid;
    this.sectionId = params.sectionId || "";
    this.noticeType = params.noticeType || "1";
    this.getBaseInfo();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    // 设置seo
    updateSEO() {
      if (this.baseInfo) {
        const dynamicData = {
          title: this.baseInfo.gonggaoTitle || "",
          region: this.baseInfo.projectLocation || "",
          category:
            this.baseInfo.purchaseCategory ||
            this.baseInfo.purchaseMajorCategory ||
            "",
          orgName: this.baseInfo.organizationUnit || "",
          categoryType: this.baseInfo.purchaseMajorCategory || "",
          budget: this.baseInfo.budgetMoneyFormat || "",
          status: this.baseInfo.statusName || "",
        };

        const seoConfig = getSEOConfig(this.$route.path, dynamicData);
        setPageSEO(seoConfig);
      }
    },
    setTitle(title) {
      this.baseInfo.gonggaoTitle = title || this.baseInfo.gonggaoTitle;
    },
    formatterDateTime,
    // 获取基础信息
    getBaseInfo() {
      const params = {
        id: this.id,
        infoid: this.infoid,
        sectionId: this.sectionId,
      };
      purchaseApi.baseInfo(params).then((res) => {
        console.log("基础信息", res);
        if (res.code === 0) {
          const data = res.data || {};
          const sectionList = data.sectionList || [];
          data.status_name =
            PROJECT_STATUS_BUTTON_TEXT[data.status] ||
            PROJECT_STATUS_BUTTON_TEXT.default;
          this.baseInfo = data;
          sectionList.forEach((item) => {
            item.gonggaoFbstartDateStr = formatterDateTime(
              item.gonggaoFbstartDate,
            );
          });
          this.sectionList = sectionList;
          if (this.sectionList.length === 1) {
            this.sectionId = this.sectionList[0].id;
          }
          this.$store.commit(
            "permission/SET_DETAIL_TITLE",
            this.baseInfo.gonggaoTitle,
          );
          this.updateSEO();
        }
        this.isReady = true;
      });
    },
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const str =
        "background-color: #f9f9f9;padding: 8px 0;text-align: center;";
      return str;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = "padding: 10px 0;";
      if (columnIndex === 2) {
        str += "display: flex;justify-content: center;";
      }
      return str;
    },
    updateUrlWithoutReload(newPath, newQuery) {
      const url = new URL(window.location.href);

      if (newPath) {
        url.pathname = newPath;
      }

      if (newQuery) {
        Object.keys(newQuery).forEach((key) => {
          url.searchParams.set(key, newQuery[key]);
        });
      }
      // 使用 replaceState 更新 URL 而不触发页面刷新
      window.history.replaceState({}, "", url.href);
    },
    // 选择类别
    selectNoticeType(type) {
      if (type !== this.noticeType) {
        this.noticeType = type;
        this.updateUrlWithoutReload(this.$route.path, {
          ...this.$route.query,
          id: this.id,
          noticeType: type,
        });
        this.getDetail();
      }
    },
    // 跳转
    openLogin() {
      if (this.baseInfo.signUpUrl) {
        window.open(this.baseInfo.signUpUrl);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding-bottom: 20px;
}
.page-show {
  opacity: 1;
}
.page-hide {
  opacity: 0;
  transition: all 0.5s;
}
.detail-header {
  border: 1px solid #ddd;
  background-color: #fff;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 94px;
    line-height: 36px;
    text-align: center;
    font-size: 26px;
    font-weight: bold;
  }
  .detail-info {
    border-top: 1px solid #ddd;
    padding: 30px 0;
    font-size: 16px;
    .detail-info-item {
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      .application-btn {
        width: 90px;
        height: 32px;
        border-radius: 0;
        padding: 0;
        margin-top: 14px;
        &.is-disabled {
          background-color: #ddd;
          border-color: #ddd;
        }
      }
      .disabled {
        background-color: #ddd;
        border-color: #ddd;
      }
    }
    .detail-info-item + .detail-info-item {
      border-left: 1px solid #ddd;
    }
  }
}
.notice-list {
  height: 100px;
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 0 37px;
  background-color: #fff;
  .notice-item {
    width: 250px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    font-size: 20px;
    color: #999;
    cursor: not-allowed;
    img {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
  .can-view {
    cursor: pointer;
    color: $--color-primary;
  }
  .active {
    cursor: pointer;
    background: $--color-primary;
    color: #fff;
  }
}
.detail-table {
  margin-top: 20px;
  border: 1px solid #ddd;
  border-bottom: 0;
  &::before {
    height: 0;
  }
  .select-btn {
    width: 70px;
    height: 24px;
    padding: 0;
    text-align: center;
    border-radius: 0;
    &.is-active {
      background-color: $--color-primary;
      color: #fff;
    }
  }
}
.detail-content {
  background-color: #fff;
  padding: 0 20px;
  border: 1px solid #ddd;
  margin-top: 20px;
  .detail-content-header {
    height: 136px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
